<template>
  <transition name="slide-fade">
    <div
      class="spritesStore"
      v-show="boxData.judgeBox"
      :style="{
        'top'     : boxData.fix.y+'px', 
        'left'    : boxData.fix.x+'px', 
        'z-index' : boxData.Zindex, 
    }"
      @mousedown="stopDocument($event)"
    >
      <div
        class="dragArea"
        v-on:mousedown="moveStart($event, true)"
        v-on:mousemove="moveArea($event)"
        v-on:mouseup="saveMoveState($event)"
        :style="{'cursor': 'move'}"
      >
        <i class="el-icon-close" @click="close()"></i>
      </div>
      <div class="spritesStore_body">
        <p>素材定制商城</p>
        <div class="wechatImg">
          <img width="100%" height="100%" src="../../../static/img/wechartLaihua.jpg" />
        </div>
        <div class="imgDesign">
          <span>扫码进入小程序</span>
          <span>可定制您的专属素材</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// 废弃
import { mapGetters } from "vuex";
import Analysis from "../mixins/analysis/materialBu";
import popup from "../mixins/popup";

export default {
  mixins: [Analysis, popup],
  data() {
    return {
      spriteType: "spritesStore"
    };
  },
  watch: {
    "boxData.judgeBox": {
      handler(val) {
        if (val) {
        } else {
        }
      }
    }
  },
  props: ["dataMsg", "boxDatas"],
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectScenes_Msg",
      "TopNav_Size",
      "MaterialPane_Size",
      "S_GlobalSearch",
      "isClipboardEmpty",
      "UserEquity",
      "UserLevel",
      "UserLevelType",
      "UserMsg"
    ])
  },
  mounted() {},
  methods: {},
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.spritesStore {
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 276px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  z-index: 35;
  overflow: hidden;
  text-align: left;

  .dragArea {
    height: 32px;
    font-size: 12px;
    padding: 10px;
    text-align: right;
    color: #737596;
    i {
      cursor: pointer;
    }
  }

  .spritesStore_body {
    width: 100%;
    height: 245px;
    padding: 0 54px;
    p {
      width: 132px;
      height: 20px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: 700;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #474261;
      text-align: center;
      margin-bottom: 15px;
    }
    .wechatImg {
      width: 132px;
      height: 132px;
      background-color: #f0f0f8;
    }
    .imgDesign {
      padding-top: 15px;

      span {
        display: block;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #474261;
        text-align: center;
      }
    }
  }
}

.icon-upload-sound {
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  height: 0px;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/spritesStore.vue